import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const SelectedOrganizationContext = createContext();

export const SelectedOrganizationProvider = ({ children }) => {
  const [selectedOrganization, setSelectedOrganization] = useState(() => {
    const orgId = localStorage.getItem("organizationId");
    return orgId ? Number(orgId) : null;
  });

  const setSelectedOrganizationWithPersist = (orgId) => {
    const nextOrgId = orgId === "" ? null : orgId;
    setSelectedOrganization(nextOrgId);
    if (nextOrgId === null || typeof nextOrgId === "undefined") {
      localStorage.removeItem("organizationId");
    } else {
      localStorage.setItem("organizationId", String(nextOrgId));
    }
  };

  const selectedOrganizationPayload = useMemo(
    () =>
      selectedOrganization !== null ? { condition: { organizationId: selectedOrganization } } : {},
    [selectedOrganization],
  );

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "organizationId") {
        const newOrgId = event.newValue;
        setSelectedOrganization(newOrgId ? Number(newOrgId) : null);
      }
    };

    // Also listen for custom organization change event from GlobalConfig
    const handleOrganizationChange = (event) => {
      if (event.detail && event.detail.organizationId) {
        setSelectedOrganization(event.detail.organizationId);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("organizationChange", handleOrganizationChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("organizationChange", handleOrganizationChange);
    };
  }, []);

  const ctxValue = useMemo(
    () => ({
      selectedOrganization,
      setSelectedOrganization: setSelectedOrganizationWithPersist,
      selectedOrganizationPayload,
    }),
    [selectedOrganization, selectedOrganizationPayload],
  );

  return (
    <SelectedOrganizationContext.Provider value={ctxValue}>
      {children}
    </SelectedOrganizationContext.Provider>
  );
};

export const useSelectedOrganization = () => {
  return useContext(SelectedOrganizationContext);
};
